/**
 * Shared navigation group/section header.
 *
 * Non-interactive label used to separate groups of nav items
 * (e.g. "CRM", "Account", "Integrations"). Source strings are natural-case;
 * the uppercase eyebrow treatment comes from the `uppercase` CSS class here.
 */

interface NavGroupHeaderProps {
  /** Display label for the group. */
  label: string;
}

export function NavGroupHeader({ label }: NavGroupHeaderProps) {
  return (
    <span
      role='heading'
      aria-level={3}
      // `uppercase` is load-bearing: source strings are natural-case; removing it requires re-casing them at every call site.
      className='block pb-1 pt-3 text-xs font-bold uppercase text-tertiary'
    >
      {label}
    </span>
  );
}
